import React, { useEffect } from 'react';
import styles from './RegistrationForm.module.scss';
import World from '../../world';
import useRegister from '../../hooks/useRegister';
import { LogoContainer } from '../LogoContainer';
import TextInput from '../TextInput';
import { Submit } from '../Submit';
import ActionLink from '../ActionLink';
import { Facebook } from "../OIDC";

type Props = {
  world: World;
  onSuccess: () => void;
  discount?: string;
};

export const RegistrationForm = (props: Props) => {
  const { onChange, onSubmit, isPending, error } = useRegister(props.world, props.onSuccess, props.discount);

  useEffect(() => {
    (window as any).fbq('track', 'Lead');
  }, []);

  return (
    <div className={styles['registration-form']}>
      {!props.discount ? <LogoContainer /> : <></>}

      {error && (
        <p>
          <span className="form-error">{error.message}</span>
        </p>
      )}

	  <Facebook />
			<br />
			<br />
			<hr style={{color: "#eeeeee" }} />
			<br />

      <form onSubmit={onSubmit}>
        <TextInput name="full_name" onChange={onChange} placeholder="name" help="Enter Your Name" />

        <TextInput name="email" type="email" onChange={onChange} placeholder="email" help="Enter Your Email" />

        <TextInput name="password" type="password" onChange={onChange} placeholder="password" help="Enter Your Password " />

        <Submit label="Sign Up Now" is_pending={isPending} />
      </form>

      <br />
      <ActionLink secondary to="/dashboard/login">
        Login
      </ActionLink>
    </div>
  );
};

export default RegistrationForm;
